import { useEffect, useState } from 'react'
import { translations } from '../../../configs/translations'
import { Language } from '../../../context/LanguageContext'
import { Vehicle } from '../../../models/Vehicle'
import './VehicleInfo.css'

export interface VehicleInfoProps {
	selectedVehicle: Vehicle
}

export const VehicleInfo = ({ selectedVehicle }: VehicleInfoProps) => {
	const [language, setLanguage] = useState<Language>('ru')
	const t = translations[language]

	const [color, setColor] = useState<string>('green')
	const [title, setTitle] = useState<string>(t.vehicle_is_ready)

	useEffect(() => {
		setColor(getVehicleInfoColor())
		setTitle(getVehicleInfoTitle())
	}, [selectedVehicle])

	const getVehicleInfoTitle = () => {
		if (selectedVehicle?.inRace) {
			return t.vehicle_is_in_race
		} else if (selectedVehicle?.damage) {
			return t.vehicle_is_damaged
		}
		return t.vehicle_is_ready
	}

	const getVehicleInfoColor = () => {
		if (selectedVehicle?.inRace) {
			return 'red'
		} else if (selectedVehicle?.damage) {
			return 'red'
		}
		return 'green'
	}

	return (
		<div className={`vehicle-info-title ${color}`}>{title}</div>
	)
}